import { useParams } from 'next/navigation'

import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'

import { useStorefrontId } from '@/app/buy/seller/[sellerSlug]/StorefrontContext'
import { FeatureFlags } from '@/helpers/featureFlags'

export const useStorefrontSearchConfig = (
  variant: 'default' | 'storefront'
) => {
  const universalSearchFlag = useFlag(
    FeatureFlags.ENABLE_UNIVERSAL_SEARCH_BAR_TOP_NAV
  )
  const params = useParams()
  const sellerSlug = params?.sellerSlug as string | undefined
  const contextStorefrontId = useStorefrontId()

  let shouldShowSearch: boolean
  let isStorefrontExcluded = false
  if (
    variant === 'storefront' &&
    typeof universalSearchFlag === 'object' &&
    universalSearchFlag.enabled
  ) {
    if (sellerSlug) {
      if (universalSearchFlag.excludedStorefrontSlugs?.includes(sellerSlug)) {
        isStorefrontExcluded = true
      }
    } else if (contextStorefrontId) {
      if (
        universalSearchFlag.excludedStorefrontIds?.includes(contextStorefrontId)
      ) {
        isStorefrontExcluded = true
      }
    }
    shouldShowSearch = !isStorefrontExcluded
  } else {
    shouldShowSearch = false
  }
  shouldShowSearch = shouldShowSearch || variant !== 'storefront'

  return {
    shouldShowSearch,
    hideNavigation: isStorefrontExcluded,
  }
}
